export default {
  // 实时变化Signature
  makeSignature(params, reqTime) {
    let paramsKeys = Object.keys(params).sort();
    let paramsStr = "";
    for (let paramsKey of paramsKeys) {
      paramsStr += `${paramsKey}=${params[paramsKey]}&`;
    }
    return $.md5(paramsStr + reqTime);
  },

  // 获取网站来源
  getUrlParam(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },

  // gTag
  gtag() {
    dataLayer.push(arguments);
  },
  // 时间
  tsformat(ts) {
    const time = new Date(String(ts).length === 13 ? ts : ts * 1000);
    return `${time.getFullYear()}/${time.getMonth() + 1}/${time.getDate()}`;
  },

  getQuerys(e) {
    if (!e) return "";
    var t = {},
      r = [],
      n = "",
      a = "";
    try {
      var i = [];
      if (
        (e.indexOf("?") >= 0 &&
          (i = e.substring(e.indexOf("?") + 1, e.length).split("&")),
        i.length > 0)
      )
        for (var o in i) (n = (r = i[o].split("="))[0]), (a = r[1]), (t[n] = a);
    } catch (s) {
      t = {};
    }
    return t;
  },
  // style函数
  handleScale() {
    let winWidth = $(window).width();
    let winHeight = $(window).height();
    const contScale = Math.min(
      winWidth / winHeight / (1920 / 1080),
      winHeight / winWidth / (1080 / 1920)
    );
    return {
      transform: "matrix(" + contScale + ", 0, 0, " + contScale + ", 0, 0)"
    };
  },
  // 宽高比
  handleVideoSize() {
    const scalex = $(window).width() / 1920;
    const scaley = $(window).height() / 1080;
    const vscale = Math.max(scalex, scaley);
    const vwidth = 1920 * vscale;
    const vheight = 1080 * vscale;

    return {
      width: vwidth + "px",
      height: vheight + "px",
      marginLeft: -vwidth / 2 + "px"
    };
  },

  goShare(code) {
    switch (code) {
      case "fb":
        window.open(`https://www.facebook.com/LegendOfBraveheart/`, "_blank");
        gtag("event", "facebook_page");
        break;
      case "dc":
        window.open(`https://discord.gg/cTpmzEPjCG`, "_blank");
        gtag("event", "discord_page");
        break;
      case "yt":
        window.open(`https://www.youtube.com/@LEGENDOFBRAVEHEART`, "_blank");
        gtag("event", "youtube_page");
        break;
      case "gp":
        window.open(
          `https://play.google.com/store/apps/details?id=com.ujoy.braveheart.aos`,
          "_blank"
        );
        gtag("event", "GP_down");
        break;
      case "ios":
        window.open(`https://apps.apple.com/app/id6749419759`, "_blank");
        gtag("event", "AS_down");
        break;
      case "apk":
        window.open(`https://lob.ujoygames.com/com.ujoy.braveheart.web.apk`, "_blank");
        gtag("event", "APK_down");
        break;
    }
  }
};



// WEBPACK FOOTER //
// ./src/commonFunction/common.js